import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Link from "../../Link";
import { useDebouncedEffect } from "../../../lib/useDebouncedEffect";
import { fetchJson } from "../../../lib/Fetching";
import Checkbox from "../../common/form/Checkbox";
import _ from "underscore";

const SearchBox = styled.div`
  display: flex;
`;
const Options = styled.div`
  min-height: 200px;
  max-height: 200px;
  overflow-y: scroll;
  border: 1px solid #ddd;

  & .option {
    border-bottom: 1px solid #ddd;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;

    & label {
      margin: 0px;
      margin-right: 10px;
    }
  }
`;

export default function Search({
  url,
  paramsBuilder,
  nameField = "name",
  values,
  onChange,
  placeholder,
}) {
  const [value, setValue] = useState("");
  const [options, setOptions] = useState([]);

  const find = () => {
    if (!value || value.length < 3) return;
    fetchJson(url, paramsBuilder(value)).then((json) => {
      setOptions(json);
    });
  };

  useDebouncedEffect(find, [value], 300);

  const updateSearch = (e) => {
    setOptions([]);
    setValue(e.target.value);
  };

  const onSelect = (options, checked) => {
    if (checked) {
      onChange(_.uniq(values.concat(options), (o) => o.id));
    } else {
      const ids = options.map((o) => o.id);
      onChange(values.filter((value) => !ids.includes(value.id)));
    }
  };

  const disabled = options.length == 0;

  return (
    <div>
      <SearchBox>
        <input
          type="text"
          onChange={updateSearch}
          value={value}
          className={"form-control"}
          placeholder={placeholder}
          style={{ width: "90%", borderRadius: 20, borderWidth: 1, borderColor: "#666" }}
        />
        <div
          style={{
            textAlign: "center",
            width: "10%",
            paddingTop: 5,
            paddingLeft: 5,
            fontSize: 14,
          }}
        >
          <i className="fa fa-search" />
        </div>
      </SearchBox>
      <div>
        <Link style={{ opacity: disabled ? 0.5 : 1 }} onClick={() => onSelect(options, true)}>
          Select All
        </Link>
        &nbsp;|&nbsp;
        <Link style={{ opacity: disabled ? 0.5 : 1 }} onClick={() => onSelect(options, false)}>
          Select None
        </Link>
      </div>
      <Options>
        {options.map((o) => (
          <div className="option">
            <label>
              <Checkbox
                checked={values.map((v) => v.id).includes(o.id)}
                onChange={(e) => onSelect([o], e.target.checked)}
              />
            </label>
            {o.name}
          </div>
        ))}
      </Options>
    </div>
  );
}
